export default __webpack_public_path__ + "static/media/parents_meeting.d78855c7.jpg";